import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProgressTabs.css';

const ProgressTabs = ({ currentStep, mini = false }) => {
  const steps = ['Google', 'Phone', 'Consent',
    'Test', 'Client Name',
    'Appointment', 'Invite'];

  const stepURLs = [
    '/tools/reminders/step1',
    '/tools/reminders/step-trainer-phone',
    '/tools/reminders/step-consent',
    '/tools/reminders/step-trainer-test',
    '/tools/reminders/stepclientname',
    '/tools/reminders/stepnextappointment',
    '/tools/reminders/stepinviteclient'
  ];
  const navigate = useNavigate();

  const progressPercentage = ((currentStep) / steps.length) * 100;
  const percentText = `${Math.round(progressPercentage)}% complete`;

  // Calculate segment positions for demarcation
  const segmentLines = steps.map((_, idx) => {
    if (idx === 0) return null; // Don't show at start
    const left = `${(idx / steps.length) * 100}%`;
    return (
      <div
        key={idx}
        className="progress-bar-segment"
        style={{ left }}
      />
    );
  });

  return (
    <div className={`progress-tabs-container fogged-card${mini ? ' mini' : ''}`}> 
      <div className="progress-bar-area">
        <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
        <div className={`progress-bar-overlay-text${mini ? ' mini' : ''}`}
          style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: 'auto', minWidth: '40px', justifyContent: 'center', alignItems: 'center', display: 'flex', position: 'absolute', zIndex: 10 }}>
          {percentText}
        </div>
        {!mini && (
          <div className="progress-bar-segments">
            {segmentLines}
          </div>
        )}
      </div>
      {!mini && (
        <div className="progress-tabs-wrapper">
          <div className="progress-tabs">
            {steps.map((step, index) => (
              <React.Fragment key={index}>

                  {/* onClick={() => navigate(stepURLs[index])} */}
                <span
                  className={`progress-tab ${index === currentStep ? 'active' : ''}`}
                >
                  {index+1}. {step}
                </span>
                {/* Arrow between them if not the last step */}
                {index < steps.length - 1 && (
                  <span className="progress-arrow">→</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressTabs;